module.exports = "ul {\n    text-align: center;\n  }"